import { CallType } from 'types/call.type';

/** Call statuses shown on Live Monitor (active / in-flight only). */
export const LIVE_MONITOR_ACTIVE_STATUSES = [
    CallType.PENDING,
    CallType.QUEUED,
    CallType.DIALING,
    CallType.RINGING,
    CallType.IN_PROGRESS,
    CallType.TRANSFER_IN_PROGRESS,
    CallType.HUMAN_ON_CALL,
] as const;

export const LIVE_MONITOR_ACTIVE_STATUS_FILTER = LIVE_MONITOR_ACTIVE_STATUSES.join(',');

export const LIVE_MONITOR_STATUS_OPTIONS = LIVE_MONITOR_ACTIVE_STATUSES.map((status) => ({
    value: status,
    label: status
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase()),
}));

export const LIVE_MONITOR_POLL_INTERVAL_MS = 10_000;
